




















































































































































































































































































































































































































































































































































































































































































































































































































































































































































import 'bootstrap-vue';
import Vue from 'vue';
import Component from 'vue-class-component';
import {DateTimeFormatOptions} from "vue-i18n";
import Multiselect from 'vue-multiselect';
import {Prop} from "vue-property-decorator";
import DatePicker from "vue2-datepicker";
import CBudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import {setNameLang} from "@/modules/budget-request/components/js/some-functions";
import BudgetHeaderBip from '@/modules/budget/bip/budget-header-bip.vue';
import NameLg from '@/modules/budget/bip/name_lg.vue';
import FileLoad from '@/modules/budget/bip/file-load.vue';
import FileUpload from '@/modules/budget/bip/file-upload.vue';
import {
    BipProjectDataClass,
    CriteriaIndicators,
    RowNewFinanceData,
    RowOldFinanceData,
    findItem,
    doNum,
    getRowKey,
    makeToast,
    sortByField,
    checkFinDoubles,
    checkFinNulls,
    checkFinCosts,
    setVariants,
    doRowKey,
    DEFAULT_ARRAY,
    DEFAULT_MAP,
    initLogging,
    trMsg,
    MSG_SMS, MSG_BIP, MSG_CARD_SEC, MSG_FILTER, MSG_FIELD, MSG_CDF,
    showConfirmation,
    itemNameLocale,
    yesNo,
    nameLocale,
    postData,
    DEFAULT_OBJECT
} from './bip-types';
import i18nService from "@/services/i18n";
import axios from "axios";
import {CUR_YEAR} from "@/modules/budget-request/components/js/budgetCurYear";
import FilesUpdown from "@/modules/budget-request/FilesUpdown.vue";

// декоратор @Component указывает, что класс — это компонент Vue
@Component({
    name: 'bip-card',
    components: {
        FilesUpdown,
        DatePicker,
        'multiselect': Multiselect,
        'c-budg-form-lst': CBudgetFormsList,
        BudgetHeaderBip,
        FileLoad,
        FileUpload,
        NameLg
    }
})

export default class BipCard extends Vue {
    $refs!: {
        budgetHeader: HTMLFormElement;
    };

    @Prop({ required: true, default: DEFAULT_OBJECT }) private location: any;
    @Prop({ required: true, default: DEFAULT_OBJECT }) private bip!: BipProjectDataClass;
    @Prop({ required: false, default: DEFAULT_OBJECT }) private variant: any;

    @Prop({ required: true, default: DEFAULT_ARRAY }) private regionList!: any[];
    @Prop({ required: false, default: DEFAULT_ARRAY }) private abpBase!: any[];
    @Prop({ required: false, default: DEFAULT_ARRAY }) private regAbpBase!: any[];
    @Prop({ required: false, default: DEFAULT_ARRAY }) private dataTypeList!: any[];
    @Prop({ required: false, default: DEFAULT_ARRAY }) private spfList!: any[];
    @Prop({ required: false, default: DEFAULT_ARRAY }) private directionList!: any[];
    @Prop({ required: false, default: DEFAULT_ARRAY }) private gpList!: any[];
    @Prop({ required: false, default: DEFAULT_ARRAY }) private expTypes!: any[];
    @Prop({ required: false, default: DEFAULT_ARRAY }) private bipLinkCriterias!: any[];
    @Prop({ required: false, default: DEFAULT_ARRAY }) private bipList!: any[];
    @Prop({ required: false, default: DEFAULT_ARRAY }) private prevBipList!: any[];
    @Prop({ required: false, default: DEFAULT_ARRAY }) private versionList!: any[];
    @Prop({ required: false, default: DEFAULT_ARRAY }) private fundSrcList!: any[];

    @Prop({ required: false, default: DEFAULT_MAP }) private criteriaValues!: Map<any, any>;
    @Prop({ required: false, default: DEFAULT_MAP }) private signMap!: Map<any, any>;

    @Prop({ required: false, default: false }) private showForm!: boolean;
    @Prop({ required: false, default: false }) private backList!: boolean;
    @Prop({ required: false, default: true }) private reading!: boolean;
    @Prop({ required: false, default: false }) private editSection4!: boolean;
    @Prop({ required: false, default: false }) private saving!: boolean;
    @Prop({ required: false, default: false }) private updateMark!: boolean;


    private MSG_BIP = MSG_BIP;
    private MSG_FILTER = MSG_FILTER;
    private MSG_SMS = MSG_SMS;
    private MSG_CDF = MSG_CDF;
    private MSG_FIELD = MSG_FIELD;
    private MSG_CARD_SEC = MSG_CARD_SEC;
    private yesNo = yesNo;

    private radioOptions: any [] = [
        {text: '-1', value: -1},
        {text: '0', value: 0},
        {text: '1', value: 1}
    ];
    private calcFlds: any [] = [
        'value',
        'weight',
        'max',
        'min'
    ];

    private agrObj: any = null;
    private bipYear: number = CUR_YEAR;
    private begYear = 0;
    private endYear = 0;

    private bipProjectData: BipProjectDataClass = new BipProjectDataClass();
    private selectedBip: BipProjectDataClass | null = null;

    private histBase: any[] = [];
    private prgList: any[] = [];
    private regPrgList: any[] = [];
    private gipList: any[] = [];
    private gipListReqId = 0; // номер последнего запроса /get-gips: ответы устаревших запросов игнорируются

    private bipRegion: any = {localityList: [{code: ''}], code: ''};
    private bipLocality: any = {code: ''};
    private gipCode: any = {code: ''};
    private curHeader: any | undefined;
    private unwatchList: Function[] = [];

    public async created() {
        initLogging('created bip-card')

        nameLocale(this.yesNo);

        document.addEventListener('click', this.closeOpenMore, true);
    }

    public async mounted() {
        initLogging('mounted bip-card')

        this.setupWatchers();
    }

    public beforeDestroy() {
        document.removeEventListener('click', this.closeOpenMore, true);
        this.unwatchList.forEach(unwatch => unwatch());
    }

    // methods

    private get calcIndicators() {
        const { bipYear, bipProjectData, bipLinkCriterias } = this;

        const settlementType = Number(bipProjectData?.localityObject?.type_of_settlement);

        const filtered = bipLinkCriterias.filter((row: any) => {
            const beginYear = Number(row.begin_year);
            const endYear = Number(row.end_year);

            return beginYear <= bipYear &&
                (row.end_year === null || endYear >= bipYear) &&
                row.project_type === bipProjectData?.projectType?.toString() &&
                row.object_type === bipProjectData?.object?.toString() &&
                Boolean(bipProjectData?.localityObject) &&
                row.place === settlementType;
        });

        return [...filtered].sort(sortByField('code'));
    }

    private get criteriaFields() {
        const getLabel = (key: string) =>
            (['min', 'max'].includes(key)) ? key.toUpperCase() : trMsg(this, MSG_FIELD + key);

        return [
            { label: getLabel('code'), key: 'code' },
            { label: getLabel('name'), key: 'name' },
            { label: getLabel('value'), key: 'value' },
            { label: getLabel('weight'), key: 'weight' },
            { label: getLabel('max'), key: 'max' },
            { label: getLabel('min'), key: 'min' },
            { label: getLabel('point'), key: 'calc' }
        ] as const;
    }

    private get curGpList(): any [] {

        const { bipYear, gpList, location } = this;

        return gpList.filter((row: any) => row.code !== null && row.code_kato !== null
            && (row.code_kato.startsWith('00') || row.code_kato.startsWith(location.code))
            && new Date(row.start_date).getFullYear() <= bipYear
            && new Date(row.end_date).getFullYear() >= bipYear)
            .sort(sortByField('name_ru'));
    }

    private get enterIndicators() {

        const { bipYear, bipLinkCriterias, bipProjectData } = this;

        const settlementType = Number(bipProjectData?.localityObject?.type_of_settlement);
        const projectType = bipProjectData?.projectType?.toString() ?? '';
        const objectType = bipProjectData?.object?.toString() ?? '';

        return bipLinkCriterias.filter((row: any) => {
            const beginYear = Number(row.begin_year);
            const endYear = Number(row.end_year);

            return beginYear <= bipYear &&
                (row.end_year === null || endYear >= bipYear) &&
                row.source_type === 'W' &&
                row.operator === 'АБП' &&
                row.project_type === projectType &&
                row.object_type === objectType &&
                row.place === settlementType;
        }).slice() // Создаем копию для иммутабельности
            .sort(sortByField('code'));
    }

    private get finaceFields(): any [] {
        const getLabel = (key: string, isSpf = false) =>
            isSpf ? trMsg(this, MSG_FIELD + key) : trMsg(this, MSG_FILTER + key);

        const baseFields = [
            { label: getLabel('prg'), key: 'prg' },
            { label: getLabel('ppr'), key: 'ppr' },
            { label: getLabel('spf', true), key: 'spf' }
        ];
        if (!this.bipProjectData) return baseFields;

        const { period } = this.bipProjectData;
        const yearFields = Array.from({ length: Number(period.endYear) - Number(period.begYear) + 1 }, (_, index) =>
            ({
                label: (Number(period.begYear) + index).toString(),
                key: (Number(period.begYear) + index).toString()
            }));

        return [
            ...baseFields,
            ...yearFields,
            { label: '...', key: 'more' }
        ];
    }

    private get histLst() {
        const result: any[] = [];
        if (!this.agrObj) return [];

        const options: DateTimeFormatOptions = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        }
        for (const el of this.histBase) {
            const tmp = Object.assign({}, el);
            tmp.updateDate = new Date(tmp.updateDate).toLocaleDateString('ru-RU', options);
            result.push(setNameLang(this.$i18n.locale, tmp));
        }

        if (this.agrObj.userId) {
            const tmp = Object.assign(this.agrObj.status_lang, this.agrObj);
            tmp.updateDate = new Date(tmp.updateDate).toLocaleDateString('ru-RU', options);
            result.push(setNameLang(this.$i18n.locale, tmp));
        }

        if (result.length > 0) {
            result.sort(sortByField('updateDate'));
        }

        return result;
    }

    private get journalFields() {
        const getLabel = (key: string, isFilter = false) =>
            isFilter ? trMsg(this, MSG_FILTER + key) : trMsg(this, MSG_FIELD + key);

        return [
            { label: getLabel('date'), key: 'updateDate' },
            { label: getLabel('user'), key: 'userName' },
            { label: getLabel('status', true), key: 'name' },
            { label: getLabel('comments'), key: 'commentTxt' }
        ] as const;
    }

    private get oldFinaceFields() {
        return [
            {
                label: trMsg(this, MSG_FILTER + 'prg'),
                key: 'prg'
            },
            {
                label: trMsg(this, MSG_FILTER + 'ppr'),
                key: 'ppr'
            },
            {
                label: trMsg(this, MSG_FILTER + 'spf'),
                key: 'spf'
            },
            {
                label: trMsg(this, MSG_CARD_SEC + '1.year'),
                key: 'year'
            },
            {
                label: trMsg(this, MSG_FIELD + 'plan'),
                key: 'plan'
            },
            {
                label: trMsg(this, MSG_FIELD + 'contractor'),
                key: 'podrad'
            },
            {
                label: trMsg(this, MSG_FIELD + 'date_conclusion_contract'),
                key: 'date'
            },
            {
                label: trMsg(this, MSG_CARD_SEC + '1.total_cost') + '(' + trMsg(this, MSG_FIELD + 'calc') + ')',
                key: 'totalCoast'
            },
            {
                label: trMsg(this, MSG_FIELD + 'SMR'),
                key: 'smp'
            },
            {
                label: trMsg(this, MSG_FIELD + 'author_control'),
                key: 'control'
            },
            {
                label: trMsg(this, MSG_FIELD + 'tech_supervision'),
                key: 'nadzor'
            },
            {
                label: '...',
                key: 'more'
            }
        ];
    }

    private get oldYearList() {
        return Array.from(
            { length: this.variant.year - 2010 },
            (_, i) => ({
                value: this.variant.year - i - 1,
                text: String(this.variant.year - i - 1)
            })
        );
    }

    private addNewFin(finalAbp: number) {
        const { bipProjectData, editSection4, reading } = this;
        if (!bipProjectData?.period) return;

        const row = new RowNewFinanceData(bipProjectData.period);

        if (finalAbp === 1) {
            editSection4 && bipProjectData.newFinace.push(row);
            return;
        }

        if (reading) return;

        if (!bipProjectData.newFinaceRegional) {
            this.$set(bipProjectData, 'newFinaceRegional', []);
        }
        bipProjectData.newFinaceRegional.push(row);
    }

    private addOldFinace() {
        if (!this.bipProjectData || this.reading) return;

        this.bipProjectData.oldFinace.push(
            new RowOldFinanceData(null, null, null, null, null, null, this.bipYear, 0)
        );
    }

    private changeCode() {
        const { selectedBip, directionList, bipYear, variant } = this;
        const { projectType, object, period } = this.bipProjectData;
        if (!selectedBip) return;

        this.bipProjectData = BipProjectDataClass.transit(variant, selectedBip);
        this.begYear = period.begYear;
        this.endYear = period.endYear;

        this.getBipRegion();
        this.getGipCode();

        if (selectedBip?.files?.length) {
            this.transitFiles(selectedBip.header.year, selectedBip.code, bipYear.toString());
        }
    } // при выборе кода БИПа с переходящих проектов

    private changePeriod() {
        if (!this.bipProjectData) return;

        this.$set(this.bipProjectData.period, '_begYear', this.begYear);
        this.$set(this.bipProjectData.period, '_endYear', this.endYear);
        ({ begYear: this.begYear, endYear: this.endYear } = this.bipProjectData.period);
    }

    private checkSignatures(form: any): boolean {
        let isValid = true;
        const checkSignature = (key: string, message: string) => {
            const sign = this.signMap.get(key);
            if (sign?.length) {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'warning'), message);
                isValid = false;
            }
        };

        checkSignature(
            doRowKey([form.header.abp, form.variant]),
            'Добавление проекта невозможно, так как запущен процесс подписания на уровне Инициатора. Необходимо отозвать ЭЦП'
        );

        if (form.header.finalAbp === 0) {
            checkSignature(
                doRowKey([form.header.regional.abp, form.variant_recipient]),
                'Добавление проекта невозможно, так как запущен процесс подписания на уровне Получателя. Необходимо отозвать ЭЦП'
            );
        }

        return isValid;
    }

    private chgGipCode() {
        // if (!this.bipProjectData || !this.gipCode) return;
        // this.bipProjectData.gipCode = this.gipCode.code;
        if (!this.bipProjectData) return;
        if (!this.gipCode?.code) {
            // выбор снят повторным кликом: возвращаем "пустой" объект (на нём держится шаблон)
            // и удаляем ключ, чтобы в form_data не попадал "gipCode": ""
            this.gipCode = { code: '' };
            this.$delete(this.bipProjectData, 'gipCode');
            return;
        }
        this.$set(this.bipProjectData, 'gipCode', this.gipCode.code);
    }

    private chgPrjType() {
        const fields: (keyof BipProjectDataClass)[] =
            [
                'finSourcePsd',
                'finSourceGe',
                'costPsd',
                'costGe',
                'dateStateExamination',
                'numStateExpertise'];

        const isExpertiseType = ['1', '2', '5', '6'].includes(this.bipProjectData.projectType);

        if (this.bipProjectData) {
            const isAtLeastOneFieldFilled = fields.some(field => {
                const value = this.bipProjectData[field];
                return value !== undefined && value !== null && value !== '' && value !== 0;
            });

            const shouldClearExpertise = isExpertiseType && isAtLeastOneFieldFilled;

            const shouldClearKazPercent = ['1', '2'].includes(this.bipProjectData.projectType)
                && this.bipProjectData.kazPercent > 0;

            if (shouldClearExpertise) {
                showConfirmation(this,
                    trMsg(this, MSG_CARD_SEC + '1.state_examination_number') + ', '
                    + trMsg(this, MSG_FIELD + 'date') + ', '
                    + trMsg(this, MSG_CARD_SEC + '1.total_cost') + ', '
                    + trMsg(this, MSG_CARD_SEC + '1.finSourcePsd')
                    + trMsg(this, MSG_SMS + 'and')
                    + trMsg(this, MSG_CARD_SEC + '1.finSourceGe')
                    + trMsg(this, MSG_SMS + 'will_be_deleted'),
                    () => {
                        fields.forEach((field: any) => {
                            this.$set(this.bipProjectData, field, null);
                        })
                        this.setCostWPsdGe();
                    },
                    () => {
                        this.$set(this.bipProjectData, 'projectType', this.bip.projectType);
                    });
            }

            if (shouldClearKazPercent) {
                showConfirmation(this,
                    trMsg(this, MSG_SMS + 'data_planned_kz_content_be_deleted'),
                    () => {
                        delete this.bipProjectData.kazPercent;
                        this.$set(this.bipProjectData, 'kazPercent', 0);
                    },
                    () => {
                        this.$set(this.bipProjectData, 'projectType', this.bip.projectType);
                    });
            }
        }

    }

    private chgObjType() {
        const { bip, bipProjectData } = this;

        if (!bipProjectData) return;

        const checkObject29 = bip.object !== bipProjectData.object && bipProjectData.object === '29';
        const hasExpertiseData = (bipProjectData.numStateExpertise?.length || bipProjectData.dateStateExamination) != null;

        if (checkObject29 && bipProjectData.kazPercent > 0) {
            showConfirmation(this,
                trMsg(this, MSG_SMS + 'data_planned_kz_content_be_deleted'),
                () => {
                    delete this.bipProjectData.kazPercent;
                    delete this.bipProjectData['_kazPercent'];
                    this.$set(this.bipProjectData, '_kazPercent', 0);
                },
                () => this.$set(this.bipProjectData, 'object', bip.object),
                trMsg(this, MSG_FILTER + 'object_type')
            );
        }

        if (checkObject29 && hasExpertiseData) {
            showConfirmation(this,
                trMsg(this, MSG_FIELD + 'date') + trMsg(this, MSG_SMS + 'and')
                + trMsg(this, MSG_CARD_SEC + '1.state_examination_number') + ' '
                + trMsg(this, MSG_SMS + 'will_be_deleted'),
                () => this.clearDataFields(['numStateExpertise', '_dateStateExamination', 'dateStateExamination']),
                () => this.$set(bipProjectData, 'object', bip.object));
        }
    }

    private changeRegion() {
        if (!this.bipProjectData || !this.bipRegion) return;
        this.bipProjectData.region = this.bipRegion.code;
    }

    private changeLocality() {
        if (!this.bipProjectData || !this.bipLocality) return;
        this.bipProjectData.localityObject = this.bipLocality;
    }

    private changeConsideration() {
        if (!this.bipProjectData) return;
        const { isConsiderationCentralGovernment, considerationGA } = this.bipProjectData;

        if (!isConsiderationCentralGovernment && considerationGA > 0) {
            showConfirmation(this,
                trMsg(this, MSG_CARD_SEC + '1.request_amount') + ' ' + trMsg(this, MSG_SMS + 'will_be_deleted'),
                () => this.$set(this.bipProjectData, 'considerationGA', 0),
                () => this.$set(this.bipProjectData, 'isConsiderationCentralGovernment', true)
            );
        }
    }

    private changeDirectCash() {
        if (!this.bipProjectData) return;
        const { isDirectCash, directCash } = this.bipProjectData;

        if (!isDirectCash && directCash > 0) {
            showConfirmation(this,
                trMsg(this, MSG_CARD_SEC + '1.EIRR') + ' ' + trMsg(this, MSG_SMS + 'will_be_deleted'),
                () => this.$set(this.bipProjectData, 'directCash', 0),
                () => this.$set(this.bipProjectData, 'isDirectCash', true)
            );
        }
    }

    private async checkFinCost(
        code: string,
        abp: number,
        prg: number,
        ppr: number | null,
        spf: number,
        year: number,
        variant: string
    ): Promise<unknown> {
        const params = new URLSearchParams({
            code,
            abp: abp.toString(),
            prg: prg.toString(),
            ppr: ppr?.toString() ?? '',
            spf: spf.toString(),
            year: year.toString(),
            variant
        });

        try {
            const response = await fetch(`/api-py/check-cost-data?${params}`);
            return await response.json();
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error';
            makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_request'),
                '/check-cost-data ' + errorMessage);
            return 0;
        }
    }

    private checkBipDouble(form: BipProjectDataClass): boolean {
        return this.bipList.some(row =>
            row.id !== form.id &&
            row.code === form.code &&
            (
                form.header.finalAbp === 1
                    ? row.variant === this.variant.variant_uuid
                    : row.variant_recipient === this.variant.variant_uuid
            )
        );
    }

    private cleanFinanceData(form: BipProjectDataClass) {
        const cleanFinanceObject = (obj: any, period: { begYear: number; endYear: number }) => {
            Object.keys(obj).forEach(key => {
                if (!this.isValidFinanceKey(key, period)) {
                    delete obj[key];
                }
            });
        };

        [form.newFinace, form.newFinaceRegional].forEach(financeArray => {
            financeArray?.forEach(item => cleanFinanceObject(item, form.period));
        });
    }

    private clearDataFields(fields: string[]) {
        fields.forEach(field => {
            this.$set(this.bipProjectData, field, field.includes('date') ? null : '');
        });
    }

    private closeOpenMore() {
        this.bipProjectData && this.bipProjectData.newFinace.forEach(el => el.openMore = false);
    }

    private collectUserIds(histBase: any[]): Set<string> {
        const userIds = new Set<string>();
        if (this.agrObj.userId) userIds.add(this.agrObj.userId);
        histBase.forEach(el => userIds.add(el.userId));
        return userIds;
    }

    private deleteItem(item: RowOldFinanceData) {
        const index = this.bipProjectData?.oldFinace?.indexOf(item);
        if (index !== undefined && index > -1) {
            this.bipProjectData.oldFinace.splice(index, 1);
        }
    }

    private async deleteNewFin(
        code: string,
        abp: number,
        version: string,
        item: RowNewFinanceData,
        arr: RowNewFinanceData[]
    ) {
        const result = await this.checkFinCost(
            code,
            abp,
            doNum(item.prg),
            item.ppr,
            doNum(item.spf),
            this.variant.year,
            version
        );

        if (doNum(result) > 0) {
            makeToast(
                this,
                'warning',
                trMsg(this, MSG_SMS + 'attention'),
                trMsg(this, MSG_SMS + 'delete_selected_prg_ppr_spf_impossible')
            );
            return;
        }

        const itemIndex = arr.indexOf(item);
        if (itemIndex > -1) {
            arr.splice(itemIndex, 1);
        }
    }

    private doNum(value: number | string | boolean | undefined | null, digit: number = 1): number {
        return doNum(value, digit);
    } // возращает число

    private async fetchUserNames(userIds: Set<string>): Promise<Map<string, string>> {
        const nameMap = new Map<string, string>();
        await Promise.all(
            Array.from(userIds).map(async userId => {
                try {
                    const response = await fetch(`/api-py/get-realm-user/${encodeURIComponent(userId)}`);
                    const result = await response.json();
                    if (result) {
                        const name = `${result.firstName || ''} ${result.lastName || ''}`.trim();
                        nameMap.set(userId, name);
                    }
                } catch (error) {
                    makeToast(this, 'danger',
                        `${trMsg(this, MSG_SMS + 'error_request')} /get-realm-user ${userId}`,
                        error.toString());
                }
            })
        );
        return nameMap;
    }

    private getBipRegion(): void {
        this.bipRegion = this.bipProjectData?.region && this.regionList?.length
            ? this.regionList.find(region => region.code === this.bipProjectData.region)
            : { localityList: [{ code: '' }], code: '' };

        this.getBipLocality();
    } // определяет элемент(выбранного БИПа) по коду като (region)

    private getGipCode(): void {
        if (this.bipProjectData?.gipCode && this.gipList?.length) {
            const found = this.gipList.find(gip => gip.code === this.bipProjectData.gipCode);
            this.gipCode = found || { code: '' };  // Если не найден - объект с пустым code
        } else {
            this.gipCode = { code: '' };
        }
        // console.log(this.bipProjectData?.gipCode, this.gipCode);
        this.getBipLocality();
    }

    private getBipLocality(): void {
        this.bipLocality = this.bipProjectData?.localityObject && this.bipRegion?.localityList?.length
            ? this.bipRegion?.localityList.find((row: any) => row.code === this.bipProjectData.localityObject.code)
            : { code: '' };
    } // определяет элемент(выбранного БИПа) по коду населенного пункта (locality)

    private async getFiles(data: any) {
        if (this.bipProjectData) {
            this.bipProjectData.files = data;
        }
    } // получает обновленный список файлов

    private getItem(code: any, field: string, list: any []) {
        return findItem(code, field, list);
    } // возвращает объект по коду с заданного списка

    private async getGipList(code: string = '') {
        const params = {
            year: this.variant.year,
            region: this.variant.region_code,
            abp: (this.bipProjectData.header?.finalAbp === 1 ?
                this.bipProjectData.header.abp : this.bipProjectData.header?.regional?.abp) || -1,
            // Добавляем code, если он должен использоваться
            ...(code && { code }) // если параметр code нужен в запросе
        };

        const reqId = ++this.gipListReqId;
        try {
            // this.gipList = await postData('/api-py/get-gips', params);
            // nameLocale(this.gipList);
            const resp = await postData('/api-py/get-gips', params);
            if (reqId !== this.gipListReqId) return;
            const gipList = Array.isArray(resp) ? resp : [];
            nameLocale(gipList);
            this.gipList = gipList;
            this.getGipCode(); // выбранный ИНГИП ищем уже в актуальном списке
        } catch (error) {
            makeToast(this, 'danger',
                `${trMsg(this, MSG_SMS + 'error_request')} /get-gips`,
                error.toString());
        }
    }

    private handleShowForm = (value: boolean) => {
        if (value && this.bip) {
            this.openBip();
        } else {
            this.curHeader = undefined;
        }
    }

    // форматирует введенное значение до digit цифр после запятой
    private inputFixed(item: any, field: any, value: any, digit: any) {
        value = value.toString().replace(/\s/g, '');
        this.$set(item, field, doNum(value, digit));
        this.setCostWPsdGe();
    }

    private isValidFinanceKey(key: string, period: { begYear: number; endYear: number }): boolean {
        const validKeys = new Set(['gr', 'pgr', 'abp', 'prg', 'ppr', 'spf', 'openMore']);
        const year = parseInt(key);

        return validKeys.has(key) || (
            !isNaN(year) &&
            year >= period.begYear &&
            year <= period.endYear
        );
    }

    private keyPress(event: any, pattern: any) {
        const regex = new RegExp(pattern);
        const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
            event.preventDefault();
            return false;
        }
        return true;
    }

    private async loadBipHist(id: number) {
        try {
            // Валидация входного параметра
            if (!id || typeof id !== 'number') {
                throw new Error(`Invalid ID: ${id}`);
            }
            // Выполнение запроса с улучшенной обработкой
            const response = await fetch(`/api-py/get-bip-agree-hist/${id}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            // Обработка пользовательских данных
            await this.setUserNames(data);

            // Иммутабельное обновление данных
            this.histBase = data;

        } catch (error) {
            makeToast(this, 'danger',
                trMsg(this, MSG_SMS + 'error_request') + ' /get-bip-agree-hist',
                error.toString());
        }
    }

    private async openBip() {
        this.curHeader = undefined;
        this.histBase = [];
        this.bipYear = this.variant.year;

        if (!this.showForm || !this.bip) return;

        this.bipProjectData = BipProjectDataClass.fromJSON(this.bip);
        if (!this.bipProjectData) return;

        if (this.bipProjectData?.id === 0) {
            this.bipProjectData.header.finalAbp = 1;
            this.setPeriodYears(this.bipProjectData.header.year);
        } else {
            if (this.bipProjectData.newProject === 0 && this.prevBipList) {
                this.selectedBip = this.prevBipList.find(row => row.code === this.bipProjectData?.code);
            }

            if (this.bipProjectData.addDatas.status?.id) {
                this.agrObj = this.bipProjectData.addDatas.status;
                await this.loadBipHist(this.agrObj.id);
            }
        }

        this.setCurParams();
        await this.getGipList();
        await checkFinCosts(this, this.bipProjectData);
    }

    private performMainChecks(form: any): boolean {
        const checks = [
            {
                condition: () => !form.nameRu?.length || !form.nameKk?.length,
                message: () => trMsg(this, MSG_SMS + 'fill_datas') +
                    trMsg(this, MSG_FIELD + 'project_name')
            },
            {
                condition: () => !form.object?.length,
                message: () => trMsg(this, MSG_SMS + 'fill_datas') +
                    trMsg(this, MSG_FILTER + 'object_type')
            },
            {
                condition: () => !form.region?.length && form.region_budget && parseInt(form.region_budget.substring(0, 2)) < 71,
                message: () => trMsg(this, MSG_SMS + 'fill_datas') +
                    trMsg(this, MSG_FIELD + 'region')
            },
            {
                condition: () => form.isConsiderationCentralGovernment && form.considerationGA === 0,
                message: () => trMsg(this, MSG_SMS + 'fill_datas') +
                    trMsg(this, MSG_CARD_SEC + '1.request_amount')
            },
            {
                condition: () => form.isDirectCash && form.directCash === 0,
                message: () =>  trMsg(this, MSG_SMS + 'fill_datas') + trMsg(this, MSG_CARD_SEC + '1.EIRR')
            },
            {
                condition: () => form.files.filter((row: any) => row.text.length === 0).length > 0,
                message: () => trMsg(this, MSG_SMS + 'fill_info_attached_docs') + '(' + trMsg(this, MSG_CARD_SEC + '1.title') + ')'
            },
            {
                condition: () => checkFinDoubles(form.oldFinace, ['prg', 'ppr', 'spf', 'year']) > 0,
                message: () => trMsg(this, MSG_SMS + 'double_prg_ppr') + '(' + trMsg(this, MSG_CARD_SEC + '3.title') + ')'
            },
            {
                condition: () => checkFinDoubles(form.newFinace, ['prg', 'ppr', 'spf', 'year']) > 0,
                message: () => trMsg(this, MSG_SMS + 'double_prg_ppr') + '(' + trMsg(this, MSG_CARD_SEC + '4.title') + ')'
            },
            {
                condition: () => checkFinDoubles(form.newFinaceRegional, ['prg', 'ppr', 'spf', 'year']) > 0,
                message: () => trMsg(this, MSG_SMS + 'double_prg_ppr') + '(' + trMsg(this, MSG_CARD_SEC + '4.title') + ')'
            },
            {
                condition: () => checkFinNulls(form.newFinace, this.prgList) > 0
                    || checkFinNulls(form.newFinaceRegional, this.regPrgList) > 0,
                message: () => trMsg(this, MSG_SMS + 'sel_prg_ppr_spf_in') + ' '
                    + 4 + ' ' + trMsg(this, MSG_BIP + 'sector')
            },
            {
                condition: () => (form.header.finalAbp === 1 && checkFinNulls(form.oldFinace, this.prgList) > 0)
                    || (form.header.finalAbp === 0 && checkFinNulls(form.oldFinace, this.regPrgList) > 0),
                message: () => trMsg(this, MSG_SMS + 'sel_prg_ppr_spf_in') + ' '
                    + 3 + ' ' + trMsg(this, MSG_BIP + 'sector')
            },
            {
                condition: () => (form.dateStateExamination === null || form.numStateExpertise.length === 0)
                    && (!['1', '2', '5', '6'].includes(form.projectType)),
                message: () => trMsg(this, MSG_SMS + 'fill_datas')
                    + trMsg(this, MSG_CARD_SEC + '1.state_examination_date')
                    + ', ' + trMsg(this, MSG_CARD_SEC + '1.state_examination_number')
            },
            {
                condition: () => (form.templateProject === null),
                message: () => trMsg(this, MSG_SMS + 'fill_datas')
                    + trMsg(this, MSG_CARD_SEC + '1.templateProject')
            }
            // ... другие проверки
        ];

        return checks.reduce<boolean>((acc, check) => {
            if (!acc) return false; // Сохраняем статус ошибки
            if (check.condition()) {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'warning'), check.message());
                return false;
            }
            return true;
        }, true);
    }

    private resetFinanceFields(form: BipProjectDataClass) {
        const resetFields = (financeArray: any[], fields: string[]) => {
            financeArray?.forEach(fin =>
                fields.forEach(field => this.$set(fin, field, null))
            );
        };

        if (this.curHeader.edited) {
            resetFields(form.newFinace, ['gr', 'abp', 'prg', 'ppr']);
        }
        if (this.curHeader.regEdited) {
            resetFields(form.newFinaceRegional, ['gr', 'abp', 'prg', 'ppr']);
        }
    }

    private reWriteBip() {
        if (this.bipProjectData?.newProject === 1) {
            if (this.bipProjectData.id === 0) {
                this.bipProjectData = new BipProjectDataClass({
                    year: this.variant.year,
                    dataType: this.variant.data_type,
                    finalAbp: 1});
                this.setPeriodYears(this.bipYear);
                this.setCurParams();
            }
        } else {
            this.selectedBip = null;
        }
        this.$delete(this.bipProjectData, 'gipCode');
        this.gipCode = { code: '' };
        // список ИНГИП зависит от года/региона/АБП, а не от характера расходов — перезапрашиваем сразу
        this.getGipList();
    } // при изменении характера расходов

    private setPeriodYears(startYear: number) {
        if (!this.bipProjectData) return;

        this.$set(this.bipProjectData.period, '_begYear', startYear);
        this.$set(this.bipProjectData.period, '_endYear', startYear + 1);
    }

    private setCurParams() {
        if (!this.bipProjectData) return;

        const { period, projectType, object } = this.bipProjectData;

        this.begYear = period.begYear;
        this.endYear = period.endYear;

        this.getBipRegion();
        this.getGipCode();
    }

    // фиксация header
    private setHeader(data: any) {
        if (!(!!(
            data &&
            this.variant &&
            data.selAbp &&
            data.selGu
        ))) return;

        this.curHeader = data;
        const form = this.bipProjectData;
        const head = {
            year: this.variant.year,
            dataType: form.header.dataType,
            abp: data.selAbp.abp,
            gu: data.selGu,
            finalAbp: data.finalAbp
        };

        if (head.finalAbp === 0) {
            const regional = {
                abp: this.curHeader.regAbp.abp,
                gu: this.curHeader.regGu,
                dataType: form.id === 0 || !form.header.regional
                    ? this.variant.data_type
                    : parseInt(form.header.regional.dataType)
            };
            this.$set(head, 'regional', regional);
        }

        this.$set(head, 'edited', data.edited || data.regEdited);
        this.$set(form, 'header', head);
        this.setParams();
        this.getGipList();
    }

    // фиксация names
    private setNames(data: any) {
        this.bipProjectData.nameRu = data.name_ru;
        this.bipProjectData.nameKk = data.name_kk;
        itemNameLocale(this.bipProjectData);
    }

    private setNewFinace(item: any, code: string, list: any) {
        const prgItem = findItem(code, 'prg', list);
        if (!prgItem) return;

        this.$set(item, 'gr', prgItem.value.gr);
        this.$set(item, 'pgr', prgItem.value.pgr);
        this.$set(item, 'ppr', null);
    }

    private setParams() {
        const form = this.bipProjectData;
        if (!form) return;

        this.setBudgetRegions(form);
        this.cleanFinanceData(form);
        this.resetFinanceFields(form);

        this.prgList = this.curHeader.selAbp.child;
        if (form.header.finalAbp === 0 && this.curHeader.regAbp) {
            this.regPrgList = this.curHeader.regAbp.child;
        }

        if (form.header?.finalAbp === 1) {
            form.newFinaceRegional = [];
            this.$set(form, 'district_budget', '');
            this.$set(form, 'variant_recipient', '');
        }
    }

    private setBudgetRegions(form: BipProjectDataClass) {
        const setRegion = (source: any, targetField: string) => {
            if (!source?.gu?.id_budget_type) return;

            const budgetTypes = source.gu.id_budget_type;
            const region = ['02'].includes(budgetTypes)
                ? this.location.region
                : ['03', '06'].includes(budgetTypes)
                    ? source.gu.id_region
                    : null;

            if (region) this.$set(form, targetField, region);
        };

        setRegion(form.header, 'region_budget');
        if (form.header.finalAbp === 0) {
            setRegion(form.header.regional, 'district_budget');
        }
    }

    private setSocEffect(data: any) {
        this.bipProjectData.socEcEffect =
            {
                text_ru: data.name_ru,
                text_kk: data.name_kk
            }
        itemNameLocale(this.bipProjectData.socEcEffect);
    }

    private setupWatchers() {
        const watchers = [
            { name: 'showForm', handler: this.handleShowForm },
            { name: 'backList', handler: (value: any) => (value && this.curHeader) && this.updateBip() },
            { name: 'saving', handler: (value: any) => (value) && this.updateBip() },
            { name: 'updateMark', handler: (value: any) => (value) && this.updateCriterias() }
        ];

        watchers.forEach(({ name, handler }) => {
            const unwatch = this.$watch(name, handler);
            this.unwatchList.push(unwatch);
        });
    }

    private async setUserNames(histBase: any[]) {
        const userIds = this.collectUserIds(histBase);
        const nameMap = await this.fetchUserNames(userIds);

        this.agrObj.userName = nameMap.get(this.agrObj.userId);
        histBase.forEach(el => el.userName = nameMap.get(el.userId));
    }

    private setCostWPsdGe() {

        this.$set(this.bipProjectData, 'costWithout',
            doNum(this.bipProjectData.totalCost)
            - doNum(this.bipProjectData.costPsd)
            - doNum(this.bipProjectData.costGe));
    }

    private totalOld(field: string) {
        return this.bipProjectData.oldFinace.reduce((sum, row: any) => sum + doNum(row[field]), 0);
    }

    private async transitFiles(oldYear: string, code: string, newYear: string) {
        try {
            const encodedYear = encodeURIComponent(oldYear);
            const encodedCode = encodeURIComponent(code);
            const encodedNewYear = encodeURIComponent(newYear);

            const response = await axios.post(
                `/api-py/file-transit/${encodedYear}/${encodedCode}/${encodedNewYear}`,
                null,
                {
                    responseType: 'blob',
                    validateStatus: (status) => status < 500
                }
            );

            if (response.status === 200) {
                console.log('Files transit successful');
            } else {
                throw new Error(`Server responded with status ${response.status}`);
            }
        } catch (error) {
            const errorMessage = error instanceof Error
                ? error.message
                : trMsg(this, MSG_SMS + 'error_unknown');

            makeToast(this, 'danger',
                trMsg(this, MSG_SMS + 'error_download'),
                errorMessage
            );
        }
    }

    private async updateBip() {
        const bipCode = '0';
        if (!this.curHeader) {
            makeToast(this, 'danger',
                trMsg(this, MSG_SMS + 'warning'),
                trMsg(this, MSG_SMS + 'resel_datas') +
                trMsg(this, MSG_FILTER + 'ABP') +
                trMsg(this, MSG_SMS + 'and') +
                trMsg(this, MSG_CARD_SEC + '1.st_establishment')
            );
            this.$emit('updateBip', {equal: false, form: undefined, save: false});
            return;
        }

        const form = this.bipProjectData;
        let save = true;

        // Инициализация варианта
        if (form.id === 0) {
            setVariants(this, form);
            save = this.checkSignatures(form) && save;
        }

        // Основные проверки
        if (this.reading && !this.editSection4) return;
        save = this.performMainChecks(form) && save;

        if (this.checkBipDouble(form)) {
            const dataType = findItem(
                form.header.finalAbp === 1 ? form.header.dataType : form.header.regional.dataType,
                'code',
                this.dataTypeList
            );

            let sms = 'Данные по проекту ' + form.code
                + ' с видом данных <<' + dataType.name + '>>'
                + ' за период ' + this.variant.year + '-' + (this.variant.year + 2)
                + ' уже присутсвуют в системе. Дублирующий проект не сохранится!';
            if (`${i18nService.locale}` === 'kk') {
                sms = form.code + 'жоба бойынша деректер,'
                    + '<<' + dataType.name + '>> деректер түрімен'
                    + this.variant.year + '-' + (this.variant.year + 2) + 'жылдар кезеңінде'
                    + 'жүйеде бар. Қайталанатын жоба сақталмайды!';
            }
            if (`${i18nService.locale}` === 'en') {
                sms = 'Project data' + form.code
                + ' with data type <<' + dataType.name + '>>'
                + ' for the period ' + this.variant.year + '-' + (this.variant.year + 2)
                + ' are already present in the system. The duplicate project will not be saved!';
            }
            makeToast(this, 'danger', trMsg(this, MSG_SMS + 'warning'), sms);
            save = save && false;
        }

        this.$nextTick(() => {
            this.$emit('updateBip', {
                form,
                equal: BipProjectDataClass.isEqual(this.bip, form),
                save,
                delete: false
            });
        });
    }

    private async updateCriterias() {
        for (const row of this.calcIndicators) {
            const item = Object.assign(new CriteriaIndicators(), row);
            const value = this.criteriaValues.get(getRowKey(item, ['code', 'link', 'begin_year']));
            if (value) {
                this.calcFlds.forEach((field) => {
                    if (field === 'value') {
                        if (this.bipProjectData
                            && this.bipProjectData.criteriaIndicators
                            && item.operator === 'CSI') {
                            this.$set(this.bipProjectData.criteriaIndicators, item?.code, doNum(value[field], 2));
                        }
                    } else {
                        if (this.bipProjectData
                            && this.bipProjectData.criteriaIndicators) {
                            this.$set(this.bipProjectData.criteriaIndicators, item?.code + field, doNum(value[field], 2));
                        }
                    }
                });
            }
            if (item.code === '41') {
                let x = 0;
                let y = 0;
                if (this.bipProjectData.header.finalAbp === 1) {
                    if (this.bipProjectData.newFinace) {
                        for (const obj of this.bipProjectData.newFinace) {
                            for (const [key, value] of Object.entries(obj)) {
                                if (parseInt(key) === parseInt(this.bipProjectData?.header?.year)) {
                                    if (['15', '28'].includes(String(obj?.ppr))) {
                                        x += parseFloat(value);
                                    }
                                    y += parseFloat(value);
                                }
                            }
                        }
                        this.$set(this.bipProjectData.criteriaIndicators, item?.code, doNum((x / y) * 100, 2));
                    }
                } else {
                    if (this.bipProjectData.newFinaceRegional) {
                        for (const obj of this.bipProjectData.newFinaceRegional) {
                            for (const [key, value] of Object.entries(obj)) {
                                if (parseInt(key) === parseInt(this.bipProjectData?.header?.year)) {
                                    if (['15', '28'].includes(String(obj?.ppr))) {
                                        x += parseFloat(value);
                                    }
                                    y += parseFloat(value);
                                }
                            }
                        }
                        this.$set(this.bipProjectData.criteriaIndicators, item?.code, doNum((x / y) * 100, 2));
                    }
                }
            }
            if (item.code === '43') {
                if (this.bipProjectData && this.bipProjectData.criteriaIndicators) {

                    if ((['27'].includes(this.bipProjectData.object) && ['1', '3'].includes(this.bipProjectData.projectType))
                        || ['7', '8'].includes(this.bipProjectData.projectType)
                        || (['42', '43'].includes(this.bipProjectData.object) && ['1', '3'].includes(this.bipProjectData.projectType))) {
                        this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                            doNum(this.bipProjectData?.costWithout) / doNum(this.bipProjectData.criteriaIndicators['137']) / 1000);
                    }

                    if (['27', '42', '43'].includes(this.bipProjectData.object) && ['2', '4'].includes(this.bipProjectData.projectType)) {
                        this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                            doNum(this.bipProjectData?.costWithout) / doNum(this.bipProjectData.criteriaIndicators['56']) / 1000);
                    }

                    if (['7', '8'].includes(this.bipProjectData.projectType)) {
                        this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                            doNum(this.bipProjectData?.costWithout) / doNum(this.bipProjectData.criteriaIndicators['137']) / 1000);
                    }
                }
            }
            if (item.code === '46') {
                if (this.bipProjectData && this.bipProjectData.criteriaIndicators) {
                    this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                        100 * doNum(this.bipProjectData.criteriaIndicators['137']) / doNum(this.bipProjectData.criteriaIndicators['148']));

                }
            }
            if (item.code === '73') {
                if (this.bipProjectData
                    && this.bipProjectData.criteriaIndicators) {
                    this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                        doNum(this.bipProjectData.criteriaIndicators['147']) * doNum(this.bipProjectData.criteriaIndicators['107']) / 1000);

                }
            }
            if (item.code === '50') {
                if (this.bipProjectData && this.bipProjectData.criteriaIndicators) {
                    if (!['17', '18', '31', '33'].includes(this.bipProjectData.object) && ['3'].includes(this.bipProjectData.projectType)) {
                        this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                            doNum(this.bipProjectData?.costWithout) / doNum(this.bipProjectData.criteriaIndicators['63']));
                    }
                    if (!['17'].includes(this.bipProjectData.object) && ['4'].includes(this.bipProjectData.projectType)) {
                        this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                            doNum(this.bipProjectData?.costWithout) / doNum(this.bipProjectData.criteriaIndicators['153']));
                    }
                    if (['17'].includes(this.bipProjectData.object)) {
                        this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                            doNum(this.bipProjectData?.costWithout) / doNum(this.bipProjectData.criteriaIndicators['49']));
                    }
                    if (['18', '31', '33'].includes(this.bipProjectData.object) && ['3'].includes(this.bipProjectData.projectType)) {
                        this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                            doNum(this.bipProjectData?.costWithout) / doNum(this.bipProjectData.criteriaIndicators['146']));
                    }

                }
            }
            if (item.code === '65') {
                if (this.bipProjectData
                    && this.bipProjectData.criteriaIndicators) {
                    this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                        doNum(this.bipProjectData.costWithout) / doNum(this.bipProjectData.criteriaIndicators['64']));

                }
            }
            if (item.code === '77') {
                if (this.bipProjectData
                    && this.bipProjectData.criteriaIndicators) {

                    if (['1', '3'].includes(this.bipProjectData.projectType)) {
                        this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                            100 * doNum(this.bipProjectData.criteriaIndicators['63']) / doNum(this.bipProjectData.criteriaIndicators['73']));
                    }
                    if (['2', '4'].includes(this.bipProjectData.projectType)) {
                        this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                            100 * doNum(this.bipProjectData.criteriaIndicators['153']) / doNum(this.bipProjectData.criteriaIndicators['73']));
                    }
                }
            }
            if (item.code === '87') {
                if (this.bipProjectData
                    && this.bipProjectData.criteriaIndicators) {

                    if (['3'].includes(this.bipProjectData.projectType)) {
                        this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                            doNum(this.bipProjectData.costWithout) / doNum(this.bipProjectData.criteriaIndicators['150']));
                    }
                    if (['4'].includes(this.bipProjectData.projectType)) {
                        this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                            doNum(this.bipProjectData.costWithout) / doNum(this.bipProjectData.criteriaIndicators['56']));
                    }

                }
            }
            if (['89', '90'].includes(item.code)) {
                if (this.bipProjectData
                    && this.bipProjectData.criteriaIndicators) {

                    this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                        doNum(this.bipProjectData.criteriaIndicators['64']) / doNum(this.bipProjectData.criteriaIndicators['145']));
                }
            }
            if (item.code === '118') {
                if (this.bipProjectData
                    && this.bipProjectData.criteriaIndicators) {

                    if (['3'].includes(this.bipProjectData.projectType)) {
                        this.$set(this.bipProjectData.criteriaIndicators, item?.code,
                            doNum(this.bipProjectData.criteriaIndicators['146']));
                    }
                }
            }
        }
    }

    // translate methods
    private trMsg(field: string, params: any = null) {
        return trMsg(this, field, params);
    }
}
